export class EnumUtils {
  /**
   * check for id
   * @returns true if searchedEnum is contained in array
   */
  static checkForEnum<T>(enumList: T[], searchedEnum: T): boolean {
    let containsEnum = false;
    if (enumList && enumList.length) {
      containsEnum = enumList.some((item) => item === searchedEnum);
    }
    return containsEnum;
  }

  static getProductionInEUTranslationKey(state: string): string {
    return 'enums.inEUTypes.' + state;
  }
}
